var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function readFileToArrayBuffer(fileReference) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener("load", (e) => {
                const target = e.target;
                if (target === null) {
                    reject(new Error("No target"));
                    return;
                }
                const result = target.result;
                if (!(result instanceof ArrayBuffer)) {
                    reject(new Error("No ArrayBuffer"));
                    return;
                }
                resolve({ buffer: result, fileName: fileReference.name });
            });
            reader.readAsArrayBuffer(fileReference);
        });
    });
}
export function getFileExtension(filename) {
    return filename.slice(filename.lastIndexOf(".") + 1);
}
